import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=67418a3b&scoped=true&"
import script from "./Headlines.vue?vue&type=script&lang=js&"
export * from "./Headlines.vue?vue&type=script&lang=js&"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=67418a3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67418a3b",
  null
  
)

export default component.exports